export default __webpack_public_path__ + "static/media/minicard7.902c192d.jpg";